import helper from '@/urls/helper'

let getRecordingUrlWithParameters = helper.getRecordingUrlWithParameters
let getAdminUrlAllowed = helper.getRecordingUrlAllowed

export default {
    getAdminUrlWithParameters: getRecordingUrlWithParameters,
    ADMIN: {
        ALLOWED: () => getAdminUrlAllowed(
            'admin|cards|cards-list',
            'list',
        ),
        PERMISSION: {
            LIST:
                (gets = null) => getRecordingUrlWithParameters(
                    'admin|events|admins-list',
                    'list',
                    gets
                ),
            CREATE:
                (gets = null) => getRecordingUrlWithParameters(
                    'admin|events|admins-list',
                    'create',
                    gets
                ),
            UPDATE:
                (id, gets = null) => getRecordingUrlWithParameters(
                    'admin|events|admins-detail',
                    'update',
                    {id: id},
                    gets
                ),
            PARTIAL_UPDATE:
                (id, gets = null) => getRecordingUrlWithParameters(
                    'admin|events|admins-detail',
                    'partial_update',
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getRecordingUrlWithParameters(
                    'admin|events|admins-detail',
                    'destroy',
                    {id: id},
                    gets
                ),
        },
        EVENTS: {
            LIST:
                (gets = null) => getRecordingUrlWithParameters(
                    'admin|events-list',
                    'list',
                    gets
                ),
            CREATE:
                (gets = null) => getRecordingUrlWithParameters(
                    'admin|events-list',
                    'create',
                    gets
                ),
            UPDATE:
                (id, gets = null) => getRecordingUrlWithParameters(
                    'admin|events-detail',
                    'update',
                    {id: id},
                    gets
                ),
            DETAIL:
                (id, gets = null) => getRecordingUrlWithParameters(
                    'admin|events-detail',
                    'update',
                    {id: id},
                    gets
                ),
            PARTIAL_UPDATE:
                (id, gets = null) => getRecordingUrlWithParameters(
                    'admin|events-detail',
                    'partial_update',
                    {id: id},
                    gets
                ),
            PREDELETE:
                (id, gets = null) => getRecordingUrlWithParameters(
                    'admin|events-check',
                    'check',
                    {id: id},
                    gets
                ),
            DELETE:
                (id, gets = null) => getRecordingUrlWithParameters(
                    'admin|events-detail',
                    'destroy',
                    {id: id},
                    gets
                ),
        },
        EMAILS: {
            LIST:
                (gets = null) => getRecordingUrlWithParameters(
                    'admin|emails-list',
                    'list',
                    gets
                ),
            DETAIL:
                (id, gets = null) => getRecordingUrlWithParameters(
                    'admin|emails-detail',
                    'retrieve',
                    {id: id},
                    gets
                ),
            RESEND:
                (id, gets = null) => getRecordingUrlWithParameters(
                    'admin|emails-resend',
                    'resend',
                    {id: id},
                    gets
                ),
        },
        DATE: {
            LIST:
                (event, gets = null) => getRecordingUrlWithParameters(
                    'admin|events|dates-list',
                    'list',
                    {event: event},
                    gets
                ),
            CREATE:
                (event, gets = null) => getRecordingUrlWithParameters(
                    'admin|events|dates-list',
                    'create',
                    {event: event},
                    gets
                ),
            UPDATE:
                (event, id, gets = null) => getRecordingUrlWithParameters(
                    'admin|events|dates-detail',
                    'update',
                    {id: id, event: event},
                    gets
                ),
            DETAIL:
                (event, id, gets = null) => getRecordingUrlWithParameters(
                    'admin|events|dates-detail',
                    'update',
                    {id: id, event: event},
                    gets
                ),
            PARTIAL_UPDATE:
                (event, id, gets = null) => getRecordingUrlWithParameters(
                    'admin|events|dates-detail',
                    'partial_update',
                    {id: id, event: event},
                    gets
                ),
            DELETE:
                (event, id, gets = null) => getRecordingUrlWithParameters(
                    'admin|events|dates-detail',
                    'destroy',
                    {id: id, event: event},
                    gets
                ),
        },
        INTERVAL: {
            LIST:
                (date, gets = null) => getRecordingUrlWithParameters(
                    'admin|dates|intervals-list',
                    'list',
                    {date: date},
                    gets
                ),
            CREATE:
                (date, gets = null) => getRecordingUrlWithParameters(
                    'admin|dates|intervals-list',
                    'create',
                    {date: date},
                    gets
                ),
            UPDATE:
                (date, id, gets = null) => getRecordingUrlWithParameters(
                    'admin|dates|intervals-detail',
                    'update',
                    {id: id, date: date},
                    gets
                ),
            DETAIL:
                (date, id, gets = null) => getRecordingUrlWithParameters(
                    'admin|dates|intervals-detail',
                    'update',
                    {id: id, date: date},
                    gets
                ),
            PARTIAL_UPDATE:
                (date, id, gets = null) => getRecordingUrlWithParameters(
                    'admin|dates|intervals-detail',
                    'partial_update',
                    {id: id, date: date},
                    gets
                ),
            DELETE:
                (date, id, gets = null) => getRecordingUrlWithParameters(
                    'admin|dates|intervals-detail',
                    'destroy',
                    {id: id, date: date},
                    gets
                ),
            BLOCK:
                (date, id, gets = null) => getRecordingUrlWithParameters(
                    'admin|dates|intervals-block',
                    'block',
                    {id: id, date: date},
                    gets
                ),
            UNBLOCK:
                (date, id, gets = null) => getRecordingUrlWithParameters(
                    'admin|dates|intervals-unblock',
                    'unblock',
                    {id: id, date: date},
                    gets
                ),
            TRANSFER:
                (date, id, gets = null) => getRecordingUrlWithParameters(
                    'admin|dates|intervals-transfer',
                    'transfer',
                    {id: id, date: date},
                    gets
                ),
        },
    }
}
